import { Suspense, lazy, useState, useEffect } from 'react';
import Hero from './components/Hero';
import Section from './components/Section';
import AboutSection from './components/AboutSection';
import StaggeredMenu from './components/StaggeredMenu';
import ScrollProgress from './components/ScrollProgress';
import Preloader from './components/Preloader';
import WhatsAppButton from './components/WhatsAppButton';

// Lazy load non-critical sections
const TechStackSection = lazy(() => import('./components/TechStackSection'));
const ServicesJourney = lazy(() => import('./components/ServicesJourney'));
const ProjectsSection = lazy(() => import('./components/ProjectsSection'));
const ContactSection = lazy(() => import('./components/ContactSection'));
const MenuSection = lazy(() => import('./components/MenuSection'));
const Footer = lazy(() => import('./components/Footer'));

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Check initially
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
    { label: 'Home', ariaLabel: 'Go to home page', link: '#' },
    { label: 'About', ariaLabel: 'Learn about us', link: '#about' },
    { label: 'Services', ariaLabel: 'View our services', link: '#services' },
    { label: 'Projects', ariaLabel: 'View our projects', link: '#projects' },
    { label: 'Contact', ariaLabel: 'Contact us', link: '#contact' }
  ];

  const socialItems = [
    { label: 'GitHub', link: 'https://github.com' },
    { label: 'Twitter', link: 'https://twitter.com' },
    { label: 'LinkedIn', link: 'https://linkedin.com' }
  ];

  return (
    <div className="relative min-h-screen bg-black text-white selection:bg-orange-500/30 selection:text-orange-50">
      {isLoading && <Preloader onComplete={() => setIsLoading(false)} />}

      {!isLoading && (
        <>
          <ScrollProgress />

          <StaggeredMenu
            position="right"
            items={menuItems}
            socialItems={socialItems}
            displaySocials={false}
            displayItemNumbering={true}
            menuButtonColor="#e2e8f0" // Slate-200
            openMenuButtonColor="#ffffff"
            changeMenuColorOnOpen={true}
            colors={['#0f0f0f', '#431407', '#fdba74', '#fed7aa']} // Mild Light Orange Theme
            accentColor="#fdba74" // Orange-300
            isFixed={true}
          />



          <main>
            <Hero />

            {/* New Award-Winning About Section with Overlap Logic */}
            <div className="relative z-10 -mt-[80vh] bg-black">
              <AboutSection />

              <Suspense fallback={<div className="h-screen bg-black" />}>
                {/* Scroll-Triggered Tech Stack & Laser Animation */}
                <TechStackSection />

                {/* New Grid Morph Services Journey */}
                <ServicesJourney />

                {/* Blueprint Scanner Projects Section */}
                <ProjectsSection />

                {/* Terminal Constellation Contact Section */}
                <ContactSection />

                {/* New Flowing Menu Navigation */}
                <MenuSection />

                <Footer />
              </Suspense>
            </div>
          </main>
        </>
      )}
    </div>
  );
};

export default App;